import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faFacebook,
    faInstagram,
    faTiktok,
} from '@fortawesome/free-brands-svg-icons'

export default function Socials() {
    return (
        <ul className="flex items-center gap-2">
            <li key="instagram">
                <a
                    href="https://www.instagram.com/drippy_rugs/"
                    target="_blank"
                    rel="noreferrer"
                    className="relative group block"
                >
                    <FontAwesomeIcon
                        icon={faInstagram}
                        className="w-8 h-8 text-white group-hover:text-red-600 group-hover:scale-110 group-hover:rotate-12 duration-200"
                    />
                </a>
            </li>
            <li key="tiktok">
                <a
                    href="https://www.tiktok.com/@drippy_rugs"
                    target="_blank"
                    rel="noreferrer"
                    className="group block"
                >
                    <FontAwesomeIcon
                        icon={faTiktok}
                        className="w-7 h-7 text-white group-hover:text-red-600 group-hover:scale-110 group-hover:rotate-12 duration-200"
                    />
                </a>
            </li>
            <li key="facebook">
                <a
                    href="https://www.facebook.com/profile.php?id=100004816807190"
                    target="_blank"
                    rel="noreferrer"
                    className="group block"
                >
                    <FontAwesomeIcon
                        icon={faFacebook}
                        className="w-7 h-7 text-white group-hover:text-red-600 group-hover:scale-110 group-hover:rotate-12 duration-200"
                    />
                </a>
            </li>
        </ul>
    )
}
